import { render } from "./BlockedUsers.vue?vue&type=template&id=13e64c16&scoped=true"
import script from "./BlockedUsers.vue?vue&type=script&lang=js"
export * from "./BlockedUsers.vue?vue&type=script&lang=js"

import "./BlockedUsers.vue?vue&type=style&index=0&id=13e64c16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e64c16"]])

export default __exports__